import Platform from "../../../../../../libs/utility/Platform";
import { Theme } from "../../../../../components/constants";

export default {
    mainContainer: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        marginBottom: "30px",
    },
    titleRow: {
        display: "flex",
        flexDirection: "row",
    },
    headerTitle: {
        display: "flex",
        flexDirection: "column",
    },
    titleSubTextContainer: {
        display: "flex",
        flexDirection: "row",
        gap: "20px",
        alignItems: "center"
    },
    titleSubText: {
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "19px",
        color: Theme.DISABLED_TEXT,
    },
    searchAndAddPayerRow: {
        display: "flex",
        flexDirection: "row",
        gap: "80px",
    },
    payerListContainer: {
        display: "flex",
        flexDirection: "column",
        marginTop: "5px",
    },
    payerListActionRow: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
    },
    payerList: {
        display: "flex",
        flexWrap: "wrap",
        marginTop: "5px",
        paddingTop: "10px",
        gap: "20px",
        maxHeight: "35vh",
        overflow: "auto",
    },
    singlePayerContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "10px",
        width: Platform.isMobileView() ? "100%" : "373px",
        height: "60px",
        position: "relative",
    },
    payerInfo: {
        display: "flex",
        flexDirection: "column",
        gap: "8px",
    },
    payerCardCustomStyles: {
        padding: "10px 20px",
        cursor: "pointer",
        width: Platform.isMobileView() ? "100%" : "auto",
    },
    payerLableConstainer: {
        display:"flex"
    },
    payerLabel: {
        fontWeight: 400,
        fontSize: "20px",
        lineHeight: "24px",
        color: Theme.TEXT_PRIMARY_BLACK,
    },
    payerIdNUmberSpan: {
        fontWeight: 400,
        fontSize: "14px",
        lineHeight: "16px",
        color: Theme.DISABLED_TEXT,
    },
    fontWeight600:{
        fontWeight :"600"
    },
    payerCardNextButton:{ 
        height:"100%", 
        display:"flex", 
        alignItems:"flex-end", 
        justifyContent:"flex-end",
        position:"absolute",
        right:"0",
        bottom:"0",
    },
    activeIconStyle: { 
        top: "-10px", 
        right: "-10px"
    },
    selectAndNextBtn: {
        fontSize: "14px",
        padding:"1px 15px"
    }
}